module.exports = __webpack_public_path__ + "./assets/e9aa4dee0a9d88b3a71868b5b7230ee0.svg";